import React, { useState } from "react";
import PropTypes from "prop-types";
import { HTTP } from "../../api/resources";

export default function Naming(props) {
  const [team, setTeam] = useState(props.team);
  const [saving, setSaving] = useState(false);

  const handleSubmit = () => {
    setSaving(true)
    HTTP.patch(`/settings`, {
      team: team,
      domain_settings: null,
    }).then(response => {
      Alert.show("notice", "Settings saved!");
      setTeam(response.data);

      setSaving(false);

      window.location.reload();
    }).catch(e => {
      Alert.show("error", "Could not save. Try again or refresh.");
      setSaving(false);
    })
  }

  return (
    <div>
    <div className="card">
      <div className="card-header flex-header">
        <div>
          <h4 className="card-title">
            Naming Settings
          </h4>
        </div>
        <div>
          <button onClick={handleSubmit} name="button" className="btn btn-primary">
            {saving && <i className="fa fa-spinner-third fa-spin mr-2"></i>}
            Save
          </button>
        </div>
      </div>
      <div className="card-body">
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label htmlFor="beneficiary_title">Beneficiary Name</label>
              <input className="form-control" placeholder="Beneficiary" type="text" name="beneficiary_title" id="beneficiary_title"
                value={team.beneficiary_title}
                onChange={e => {
                  const val = e.target.value;
                  setTeam(team => {
                    return { ...team, beneficiary_title: val }
                  });
                }}
              />
            </div>

            {props.project_flag &&
            <div className="form-group">
              <label htmlFor="project_title">Project Name</label>
              <input className="form-control" placeholder="Project" type="text" name="project_title" id="project_title"
                value={team.project_title}
                onChange={e => {
                  const val = e.target.value;
                  setTeam(team => {
                    return { ...team, project_title: val }
                  });
                }}
              />
            </div>
            }

            {!props.project_flag &&
              <div className="form-group">
                <label htmlFor="project_title">Community Name</label>
                <input className="form-control" placeholder="Community" type="text" name="community_title" id="community_title"
                  value={team.community_title}
                  onChange={e => {
                    const val = e.target.value;
                    setTeam(team => {
                      return { ...team, community_title: val }
                    });
                  }}
                />
              </div>
            }
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label htmlFor="donor_title">Donor Name</label>
              <input className="form-control" placeholder="Donor" type="text" name="donor_title" id="donor_title"
                value={team.donor_title}
                onChange={e => {
                  const val = e.target.value;
                  setTeam(team => {
                    return { ...team, donor_title: val }
                  });
                }}
              />
            </div>

            {props.project_flag &&
              <div className="form-group">
                <label htmlFor="project_title">Community Name</label>
                <input className="form-control" placeholder="Community" type="text" name="community_title" id="community_title"
                  value={team.community_title}
                  onChange={e => {
                    const val = e.target.value;
                    setTeam(team => {
                      return { ...team, community_title: val }
                    });
                  }}
                />
              </div>
            }
          </div>
        </div>
      </div>
    </div>
    </div>
  );
}

Naming.propTypes = {
  team: PropTypes.object
};
